<script>
  import { fade, slide } from "svelte/transition";
  let visible = true;
  let active01 = false;
  let active02 = false;
  let active03 = false;
let active04 = false;
  function typewriter(node, { speed = 5 }) {
    const valid =
      node.childNodes.length === 1 &&
      node.childNodes[0].nodeType === Node.TEXT_NODE;

    if (!valid) {
      throw new Error(
        `This transition only works on elements with a single text node child`
      );
    }

    const text = node.textContent;
    const duration = text.length / (speed * 0.01);

    return {
      duration,
      tick: (t) => {
        const i = ~~(text.length * t);
        node.textContent = text.slice(0, i);
      },
    };
  }

  window.addEventListener("load", function () {
    // Get the container element
    var spinebtnContainer = document.getElementById("spine-controller");

    // Get all buttons with class="btn" inside the container
    var btnSpine = spinebtnContainer.getElementsByClassName("spine-unit");

    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btnSpine.length; i++) {
      btnSpine[i].addEventListener("mouseover", function () {
        var current = document.getElementsByClassName(" active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
      });
    }
  });
  const cases = [
    {
      no: "1",
      id: "ember",
      name: "Ember Design Language System",
      image: "/images/STEALTH.png",
    },
    {
      no: "2",
      id: "stepup",
      name: "StepUp",
      image: "https://proj-ash.vercel.app/images/DARK FUTURE.png",
    },
    {
      no: "3",
      id: "lynn",
      name: "lynn",
      image: "https://proj-ash.vercel.app/images/LYNN.png",
    },
  ];

  let password = "portfolioReview";
  let passwordInput = "";
  let showCase = false;
  let selectedCaseStudy = 0;
  const checkPassword = () => {
    if (passwordInput == password) {
      showCase = true;
      console.log("password is correct");
    } else {
      console.log("password is" + passwordInput);
    }
  };
  const onKeyPress = (e) => {
    if (e.charCode === 13) checkPassword();
  };
</script>

<section class="case-section">
  <div class="password-container">
    <div class="title">Case Studies</div>
    {#if showCase}
      <a
        transition:fade
        class="resume-tag"
        href="https://docs.google.com/document/d/e/2PACX-1vSA5asuIqtc32aCxCneW0qXa16-rzVnCdr25D9zD9C6hm0Q1GIekluDORHYC6CCDf4F61Um8xSoXPku/pub"
        download
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.25 7.5V13.307L9.88327 11.9403L8.82261 13.0009L11.4697 15.648L12 16.1783L12.5303 15.648L15.1774 13.0009L14.1167 11.9403L12.75 13.307V7.5H19C20.3807 7.5 21.5 8.61929 21.5 10V17C21.5 18.3807 20.3807 19.5 19 19.5H5C3.61929 19.5 2.5 18.3807 2.5 17V10C2.5 8.61929 3.61929 7.5 5 7.5H11.25Z"
            fill="white"
          />
          <path d="M12 4.5V7.5" stroke="white" stroke-width="1.5" />
        </svg>

        View Resume</a
      >{:else}
      <p>Please enter password to view case studies</p>

      <input
        type="password"
        class="password-input"
        bind:value={passwordInput}
        on:keypress={onKeyPress}
        placeholder="Enter Password"
      />
    {/if}
  </div>
  {#if active01}
    <div
      transition:slide
      class="light-box"
      on:click={() => (active01 = !active01)}
    >
      <div class="pulseLoader" />
  <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);"    
    width="100%"
   height="100%" 
   src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FGEmhtqmH0KbyOf2Si9efgw%2FIssac-Portfolio-2022%3Fpage-id%3D101%253A2099%26type%3Ddesign%26node-id%3D102-3104%26viewport%3D1506%252C714%252C0.21%26t%3DG3sBr396wCc3l1nK-1%26scaling%3Dscale-down-width%26starting-point-node-id%3D102%253A3104%26mode%3Ddesign" allowfullscreen></iframe>
    </div>
    <div class="close-modal-btn"> Close Modal   </div>
  {/if}
  {#if active02}
    <div
      transition:slide
      class="light-box"
      on:click={() => (active02 = !active02)}
    >
      <iframe
        style="border: 1px solid rgba(0, 0, 0, 0.1);"
        width="100%"
        height="100%"
        src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FGEmhtqmH0KbyOf2Si9efgw%2FPortfolio-2022%3Fpage-id%3D101%253A2099%26node-id%3D109%253A2654%26viewport%3D344%252C48%252C0.16%26scaling%3Dmin-zoom%26starting-point-node-id%3D109%253A2654"
        allowfullscreen
      />
      <div class="close-modal-btn"> Close Modal   </div>
      <div class="pulseLoader" />
    </div>
  {/if}
  {#if active03}
    <div
      transition:slide
      class="light-box"
      on:click={() => (active03 = !active03)}
    >
      <iframe
        style="border: 1px solid rgba(0, 0, 0, 0.1);"
        width="100%"
        height="100%"
        src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FGEmhtqmH0KbyOf2Si9efgw%2FPortfolio-2022%3Fpage-id%3D101%253A2099%26node-id%3D351%253A2592%26viewport%3D344%252C48%252C0.38%26scaling%3Dmin-zoom%26starting-point-node-id%3D351%253A2592"
        allowfullscreen
      />
      <div class="close-modal-btn"> Close Modal   </div>
      <div class="pulseLoader" />
    </div>
  {/if}
 
  {#if active04}
    <div
      transition:slide
      class="light-box"
      on:click={() => (active04 = !active04)}
    >
    <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="100%" height="100%" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FGEmhtqmH0KbyOf2Si9efgw%2FIssac-Portfolio-2022%3Fpage-id%3D101%253A2099%26type%3Ddesign%26node-id%3D2743-989%26viewport%3D485%252C863%252C0.24%26t%3Drzxwj2MRF04i9D81-1%26scaling%3Dmin-zoom%26starting-point-node-id%3D102%253A3104%26mode%3Ddesign" allowfullscreen></iframe>
    <div class="close-modal-btn"> Close Modal   </div>
    <div class="pulseLoader" />
    </div>
  {/if}
 
  <div class="case-study-section" id="three">
    <div class="case-container">
      <div class="case-image">
        <img class="screen-img" src="images/EI-thumbnail.png" alt="" />
      </div>
      <div class="case-text">
        <div class="case-title">360 Report</div>

        <div class="case-description">
         In order to prepare Career Coaches for the rapid changes in industry, we designed ways of assisting their workload using Data Anayltics and LLMs.
          <br> Here's how we worked together to push the boundaries of Career Coaching. 
        </div>
        {#if showCase} 
        <button transition:fade on:click={() => (active04 = !active04)}>
          Learn More
        </button>
        {:else}
          <img class="lock" src="images/lock.svg" alt="" />
        {/if}
      </div>
    </div>
  </div>

  <div class="case-study-section" id="three">
    <div class="case-container">
      <div class="case-image">
        <img class="screen-img" src="images/thumbnail.png" alt="" />
      </div>
      <div class="case-text">
        <div class="case-title">CC4</div>

        <div class="case-description">
          As one of the 2 designers responsible for the Career Coach Platform,
          it is important to me to push the quality of design, research and
          operation in the product.
          <br /> Here's how we have tackled it over the <b> last 180 days.</b>
        </div>
        {#if showCase}
          <button transition:fade on:click={() => (active03 = !active03)}>
            Learn More
          </button>
        {:else}
          <img class="lock" src="images/lock.svg" alt="" />
        {/if}
      </div>
    </div>
  </div>
  <div class="case-study-section" id="three">
    <div class="case-container">
      <div class="case-image">
        <img class="screen-img" src="images/Screen.png" alt="" />
      </div>
      <div class="case-text">
        <div class="case-title">Ember Design Language System</div>

        <div class="case-description">
          Creating Singtel's <b> Design Language System</b> used across Digital
          Experience team. Here is how we have build a
          <b>living, breathing system </b> to cater to the needs of a growing design
          team over the course of 18 months.
        </div>
        {#if showCase}
          <button on:click={() => (active01 = !active01)}>
            Read Case Study
          </button>
        {:else}
          <img class="lock" src="images/lock.svg" alt="" />
        {/if}
      </div>
    </div>
  </div>
  <div class="case-study-section" id="three">
    <div class="case-container">
      <div class="case-image">
        <img class="phone-img" src="images/phone-01.png" alt="" />
      </div>
      <div class="case-text">
        <div class="case-title">hi!Carnival</div>
        <div class="case-description">
          Singtel's first <b>award winning gamification project </b> which
          helped to drive <b> MAU by 20% </b> on our prepaid App.
        </div>
        {#if showCase}
          <button on:click={() => (active02 = !active02)}>
            Read Case Study
          </button>
        {:else}
          <img class="lock" src="images/lock.svg" alt="" />
        {/if}
      </div>
    </div>
  </div>
</section>

<style>
  button a {
    color: black;
  }

  .lock {
    margin-top: 24px;
  }

  .svg-padding {
    margin-top: 40px;
    margin-bottom: 20px;
  }

  a.resume-tag {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-content: center;
    align-items: center;
    transition: all 0.2s;
  }

  a {
    transition: all 0.1s;
    color: #ff635c;
    font-weight: 400;
  }
  a.resume-tag:hover {
    color: rgb(235, 87, 87);
  }
  a.resume-tag svg {
    margin: 20px 10px;
  }
  section {
    padding: 80px;
    padding-top: 0px;
    height: auto;
  }
  button {
    padding: 8px 16px;
    margin: 16px 0px;
    font-family: "Barlow";
    transition: 0.2s all;
    border-radius: 50px;
  }

  button:hover {
    background-color: rgba(22, 22, 22, 0.9);
    color: white;
  }

  @keyframes slide-up {
    0% {
      height: 0px;
    }
    100% {
      height: auto;
    }
  }
  .case-study-section {
    font-weight: 100;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    padding: 40px;
    margin: auto;
    height: auto;
    width: 100%;

    animation-name: slide-up;
    animation-duration: 1.3s;
    animation-fill-mode: forwards;
  }

  .case-title {
    position: static;
    width: 455px;
    padding-bottom: 16px; 
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 50px;
    color: white;
  }

  .screen-img {
    width: 100%;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    transition: 0.3s all;
  }
  .close-modal-btn{
    text-align: center;
    cursor: pointer;
    color: white;
  }

  .phone-img {
    height: 100%;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    transition: 0.3s all;
  }
  .screen-img:hover {
    transform: translateY(-2px);
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  }
  .password-input {
    padding: 8px;
    background: black;
    color: white;
    font-size: 16px;
    border: 2px solid orange;
    font-weight: 200;
    font-family: "Barlow", sans-serif;
  }
  ::placeholder {
    color: orange;
    line-height: 25px;
  font-family: "Barlow", sans-serif;
  font-weight: 700;
  opacity: 1; /* Firefox */
}

::-ms-input-placeholder { /* Edge 12 -18 */
  color: orange;
  font-weight: 700;
  opacity: 1; /* Firefox */
}
  .password-input:focus {
    border: 2px solid orange;
  }
  .phone-img:hover {
    transform: translateY(-2px);
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  }
  .case-image {
    height: 100%;
    width: 50%;
    padding: 80px;
    text-align: center;
  }
  .case-text {
    height: 100%;
    width: 50%;
    max-width: 500px;
    padding-right: 80px;

    font-weight: 200;
    font-family: "Barlow", sans-serif;
  }
  .case-container {
    display: flex;
    max-width: 1200px;
    height: 100%;
    margin: auto;
    text-align: left;
    align-items: center;
    color: white;
    font-weight: 200;
    font-family: "Barlow", sans-serif;
  }
  p {
    color: white;
    font-weight: 200;
    font-family: "Barlow", sans-serif;
  }
  .light-box {
    position: fixed;
    height: 100vh;
    width: 100%;
    background-color: rgba(1, 1, 1, 0.95);
    z-index: 100;
    top: 0px;
    margin: auto;
    padding: 40px;
    left: 0px;
    right: 0px;
  }
  .active {
    display: none;
  }
  .title {
    position: relative;
    top: 0px;
  }
  iframe {
    border-radius: 24px;
    z-index: 10;
    position: relative;
  }
  .case-image img {
    border-radius: 16px;
  }

  .pulseLoader {
    width: 4em;
    height: 4em;
    border-radius: 4em;
    background-color: #1a1a1a;
    outline: 1px solid transparent;
    animation: pulseanim 1.2s ease-in-out infinite;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    z-index: 1;
  }
  .password-container {
    text-align: center;
    margin: 40px;
  }
  @keyframes pulseanim {
    0% {
      transform: scale(0);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
  @media only screen and (max-width: 800px) {
    section {
      padding: 0px;
    }

    iframe {
      border-radius: 0px;
    }
    .case-container {
      display: flex;
      max-width: 1200px;
      height: 100%;
      margin: auto;
      text-align: center;
      align-items: center;
      flex-direction: column;
    }
    .light-box {
      padding: 10px;
      padding-top: 20px;
      border-radius: 0px;
    }
    .case-text {
      width: 100%;
      padding: 8px;
      max-width: 100%;
      margin-top: 24px;
      font-size: 16px;
    }
    .case-title {
      margin: auto;
      height: auto;
      max-width: calc(100vw - 80px);
      width: 100%;
      font-size: 24px;
      line-height: 120%;
    }
    .case-description {
      max-width: 600px;
      margin: auto;
      padding-top: 20px;
      max-width: calc(100vw - 80px);
      color: white;
      font-size: 16px;
    }
    .case-image {
      width: 100%;
      padding: 40px;
    }
    .screen-img {
      max-width: calc(100vw - 80px);
    }
  }
</style>
